var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.137,
    height: 21.113,
    viewBox: "0 0 16.137 21.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3F",
    "data-name": "3F",
    d: "M9.352,21.113c-2.986,0-6.264-.028-6.464-.032l-.091,0a2.516,2.516,0,0,1-1.626-.67,3.183,3.183,0,0,1-.742-1A4.784,4.784,0,0,1,0,17.824a.658.658,0,0,1,0-.069V9.045a.7.7,0,0,1,.714-.689H2.368V5.1a5.481,5.481,0,0,1,1.21-3.219A4.87,4.87,0,0,1,5.314.547,6.48,6.48,0,0,1,8.047,0c4.39,0,5.635,3.215,5.679,4.915V8.356h1.7a.7.7,0,0,1,.714.689V18a2.927,2.927,0,0,1-2.8,3.073C12.663,21.1,11.321,21.113,9.352,21.113ZM1.428,9.734v7.984C1.641,19.647,2.756,19.7,2.882,19.7c.077,0,3.539.032,6.471.032,1.956,0,3.277-.012,3.929-.037,1.387-.055,1.427-1.527,1.427-1.7V9.734Zm6.62-8.356A3.944,3.944,0,0,0,4.381,3.192a4.293,4.293,0,0,0-.587,1.931V8.356h8.5V4.934a3.933,3.933,0,0,0-.627-1.907A4.039,4.039,0,0,0,8.047,1.378Zm.029,15.141a.7.7,0,0,1-.714-.689v-.818a1.4,1.4,0,0,1-.737-1.217,1.451,1.451,0,0,1,2.9,0,1.4,1.4,0,0,1-.736,1.213v.822A.7.7,0,0,1,8.076,16.519Z",
    fill: "#878a99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.45f06e533044f2643a1baabc82827a48.svg";
export { ForwardRef as ReactComponent };